import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import Profile from "./Profile"; // Your existing profile component
import MFAProfile from "./MFAProfile"; // The MFA settings component we created

const ProfileTabs = () => {
  const { t } = useTranslation();
  const { updatePageName } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("profile");

  useEffect(() => {
    // Set page name based on active tab
    if (activeTab === "profile") {
      updatePageName(t("EDIT_PROFILE"));
    } else {
      updatePageName(t("SECURITY_SETTINGS"));
    }
  }, [activeTab, updatePageName, t]);

  return (
    <div className="bg-[#F9F9F9] min-h-[80vh]">
      <div className="px-3 py-4">
        {/* Tab Navigation */}
        <div className="bg-white border border-[#E9EDF9] rounded-lg shadow-sm">
          <div className="flex border-b border-gray-200">
            <button
              className={`flex-1 px-6 py-4 text-sm font-medium transition-colors duration-200 ${
                activeTab === "profile"
                  ? "border-b-2 border-LightBlue text-LightBlue bg-blue-50/50"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
              }`}
              onClick={() => setActiveTab("profile")}
            >
              <div className="flex items-center justify-center gap-2">
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
                {t("EDIT_PROFILE") || "Edit Profile"}
              </div>
            </button>
            <button
              className={`flex-1 px-6 py-4 text-sm font-medium transition-colors duration-200 ${
                activeTab === "mfa"
                  ? "border-b-2 border-LightBlue text-LightBlue bg-blue-50/50"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
              }`}
              onClick={() => setActiveTab("mfa")}
            >
              <div className="flex items-center justify-center gap-2">
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
                {t("SECURITY_SETTINGS") || "Security Settings"}
              </div>
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div className="transition-all duration-300">
          {activeTab === "profile" ? <Profile /> : <MFAProfile />}
        </div>
      </div>
    </div>
  );
};

export default ProfileTabs;
